// © Microsoft Corporation. All rights reserved.

import { getLocationHref } from "@msnews/isomorphic-util";

/**
 * localStorage key prefix for render cache object
 */
export const storagePrefix = `lastKnown_`;

/**
 * localStorage key prefix for render cache expiration timestamp
 */
export const expirationPrefix = `timestamp_`;

/**
 * localStorage key for render cache object
 */
export const renderCacheKey = `${storagePrefix}${getLocationHref()}`;

/**
 * localStorage key for render cache expiration timestamp
 */
export const renderCacheExpirationKey = `${expirationPrefix}${getLocationHref()}`;

/**
 * render-cache expiration time in ms
 * 86400000 = 24 hours in milliseconds
 */
export const defaultExpirationTimeMs = 86400000;

/**
 * River Render Cache ClassName
 */
export const riverRcClassName = "river-rc";